import useSWR from 'swr';

import { ICountriesRegion } from '@/components/account/Tabs/ProfileEdit/Address/Address';
import { getCoreApi } from '@/utility/getCoreApi';

import apiRequest from './apiRequest';

export const useCountries = () => {
  return useSWR<ICountriesRegion[]>(`${getCoreApi()}/static/countries`, (url: string) =>
    apiRequest<ICountriesRegion[]>({ url }),
  );
};

export const useCountriesRegion = (countryCode: string) => {
  return useSWR<ICountriesRegion[]>(
    countryCode ? `${getCoreApi()}/static/regions?country_code=${countryCode}` : null,
    (url: string) => apiRequest<ICountriesRegion[]>({ url }),
  );
};
